import { useQuery, useMutation } from '@tanstack/react-query';
import { ticketQueries, ticketMutations } from './tickets.queries';

export type TicketFilter = Record<string, string | number>;

export function useTickets(
  filters?: TicketFilter,
  options?: { suspense?: boolean },
) {
  return useQuery({ ...ticketQueries.list(filters), ...options });
}

export function useTicket(ticketId?: string, options?: { suspense?: boolean }) {
  return useQuery({
    ...ticketQueries.detail(ticketId || ''),
    enabled: !!ticketId,
    ...options,
  });
}

/**
 * In- and outbound references of a ticket. `outboundIds` comes from the
 * caller's loaded ticket (ticket_references) — the query waits for it.
 */
export function useReferencedTickets(ticketId: string, outboundIds?: string[]) {
  return useQuery(ticketQueries.referencedTickets(ticketId, outboundIds));
}

/** Tickets of a klant — pass the loaded ticket's client_id. */
export function useClientTickets(clientId: number | null | undefined) {
  return useQuery(ticketQueries.clientTickets(clientId));
}

/**
 * Tickets of a project, attached directly or via one of its works (CRM-chain
 * denormalization makes both one project_id filter).
 */
export function useProjectTickets(
  projectId: number,
  options?: { suspense?: boolean },
) {
  return useQuery({ ...ticketQueries.projectTickets(projectId), ...options });
}

export function useWorkTickets(workId: number) {
  return useQuery(ticketQueries.workTickets(workId));
}

export function usePostTicketEventsMutation() {
  const mut = ticketMutations.postEvents();
  return useMutation({
    ...mut,
  });
}
